import { createSlice } from "@reduxjs/toolkit";

const activeStudentSlice = createSlice({
  name: "activeStudent",
  initialState: {
    student: null,
  },
  reducers: {
    setActiveStudent: (state, action) => {
      state.student = action.payload;
    },
    clearActiveStudent: (state) => {
      state.student = null;
    },
  },
});

export const { setActiveStudent, clearActiveStudent } =
  activeStudentSlice.actions;

export default activeStudentSlice.reducer;
